import { render, staticRenderFns } from "./RecorderTest.vue?vue&type=template&id=10016d4e&"
import script from "./RecorderTest.vue?vue&type=script&lang=js&"
export * from "./RecorderTest.vue?vue&type=script&lang=js&"
import style0 from "./RecorderTest.vue?vue&type=style&index=0&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports